import { getLayout, getPaint, getStyleType, getTextField } from './layerStyler'

export default function apnLayers(map, features, enableAPNDisplay = true) {
  var props = []
  var label = []
  features.features.forEach((polygon) => {
    label = ['parcel_id']
    // if(polygon.geometry.type === "Polygon"){
    //     props = ["PARCEL_APN:APN"]//, "COUNTYNAME:County", "SITE_ADDR:Address", "SITE_CITY:City", "SITE_STATE:State", "SITE_ZIP:Zip", "SITE_PLUS_4:Zip+4", "SITE_HOUSE_NUMBER:House No.", "LATITUDE:Latitude", "LONGITUDE:Longitude"]
    //     label = ["parcel_id"]
    // } else {
    //     props = ["PARCEL_APN:APN"]
    // }
  })

  var apnSource = {
    key: 'APN_source',
    id: 'APN_source',
    type: 'geojson',
    data: features,
  }

  var apnLayer = {
    id: 'APN',
    type: getStyleType('MULTIPOLYGON'),
    source: 'APN_source',
    layout: getLayout('MULTIPOLYGON', 'visible'),
    paint: getPaint('MULTIPOLYGON', '#FFA500'),
  }

  var apnOutlineLayer = {
    id: 'APN_outline',
    type: 'line',
    source: 'APN_source',
    layout: getLayout('OUTLINE', 'visible'),
    paint: getPaint('OUTLINE', '#FFA500'),
  }

  var apnLabelLayer = {
    id: 'APN_label',
    type: 'symbol',
    source: 'APN_source',
    layout: {
      visibility: 'visible',
      'icon-image': '',
      'text-field': enableAPNDisplay
        ? getTextField(label)
        : ['format', '000-000-000'],
      'text-font': ['Roboto Condensed Bold'],
      'text-offset': [0, 0],
      'text-letter-spacing': 0,
      'text-anchor': 'top',
      'text-size': 14,
    },
    paint: {
      'text-color': '#2c2c2c',
      'text-halo-color': '#ffffff',
      'text-halo-width': 2,
    },
  }

  return { apnSource, apnLayer, apnOutlineLayer, apnLabelLayer }
}
